<template>

    <div v-if="$mq !== 'lg'">

        <stories-stats v-if="isCarousel" :stories="stories" :force="force" @select="selectStory" ref="ss"></stories-stats>

        <stories-full-screen ref="SFS"></stories-full-screen>

    </div>

</template>

<script>

import Vuex from 'vuex'

import StoriesFullScreen from '@/components/stories/StoriesFullScreen.vue'
import StoriesStats from '@/components/stories/StoriesStats.vue'

export default {

    name: 'stories',

    components: {StoriesFullScreen, StoriesStats},

    watch: {

        stats: function () {

            this.updateStories()
        }

    },

    props: {

        type: {
            type: String,
            default: ''
        },

        force: {
            type: Boolean,
            default: false
        }

    },

    computed: {

        ...Vuex.mapGetters(['stats']),

        isCarousel() {
            return this.type === 'carousel' && this.stories.length
        }
    },

    data() {
        return {
            stories: [],
            firstname: ''
        }
    },

    mounted() {

        this.updateStories()

    },

    methods: {

        selectStory(story) {
            this.$refs.SFS.open(story, this.firstname)
        },

        updateStories() {

            const stories = this.stats.stories ? this.stats.stories.slice(0) : []

            this.stories = this.sortStories(stories)

        },

        sortStories(stories) {

            const sorted = stories.sort(function (a, b) {
                const keyA = new Date(`${a.date.split('-')[0]}/01/${a.date.split('-')[1]}`)
                const keyB = new Date(`${b.date.split('-')[0]}/01/${b.date.split('-')[1]}`)

                return keyA < keyB ? 1 : -1
            })

            return sorted

        }
    }

}

</script>

<style lang="scss" scoped>


</style>
